import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { HELP_GET_CONTENT } from '../endpoints/help.endpoints';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HelpApiService {
  private readonly http = inject(HttpClient);

  getContent(key: string): Observable<{ content: string }> {
    return this.http.get<{ content: string }>(HELP_GET_CONTENT(key));
  }
}
